<div class="modal-header approval-flow-header">
  <div class="approval-flow-heading">
    <span class="approval-flow-heading__icon">
      <lucide-icon name="git-branch" [size]="19"></lucide-icon>
    </span>
    <div class="approval-flow-heading__copy">
      <h5 class="modal-title" id="approval-flow-title">{{ 'COMMON.APPROVAL_FLOW.TITLE' | translate }}</h5>
      <span class="approval-flow-subtitle" *ngIf="objectLabel">{{ objectLabel }}</span>
    </div>
  </div>
  <button *ngIf="canClose" type="button" class="close approval-flow-close" (click)="cancel()"
          [attr.aria-label]="'COMMON.BUTTONS.CLOSE' | translate">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<form #approvalFlow="ngForm" autocomplete="off" class="approval-flow-form" (ngSubmit)="save(approvalFlow)">
  <div class="modal-body approval-flow-body" tabindex="0" ngbAutofocus *blockUI="'section-block-collection-user'">

    <!-- Una fila por cambio de estado: a la izquierda el estado, a la derecha quiénes aprueban.
         En el teléfono cada fila es una tarjeta con el estado arriba. -->
    <div class="approval-flow-list" role="table" [attr.aria-labelledby]="'approval-flow-title'">
      <div class="approval-flow-list__head" role="row">
        <span role="columnheader">{{ 'COMMON.APPROVAL_FLOW.STATUS' | translate }}</span>
        <span role="columnheader">{{ 'COMMON.APPROVAL_FLOW.USERS' | translate }}</span>
      </div>

      <div class="approval-flow-row" role="row" *ngFor="let row of statusList; let index = index"
           [class.is-invalid]="approvalFlow.submitted && (userSelected[index]?.users.length < row.approvers)">
        <div class="approval-flow-row__status" role="rowheader">
          <span class="approval-flow-row__title">{{ row.title | translateField: { obj: row, property: 'title' } }}</span>
          <span class="approval-flow-row__min" *ngIf="row.approvers > 0">
            {{ 'COMMON.APPROVAL_FLOW.MIN_APPROVERS' | translate: { count: row.approvers } }}
          </span>
        </div>

        <div class="approval-flow-row__users" role="cell">
          <ng-select [items]="row.users" required [multiple]="true" [closeOnSelect]="false"
            [searchable]="true" bindLabel="fullname" class="approval-flow-select" appendTo="body"
            [placeholder]="('COMMON.PLACEHOLDER.SELECT' | translate) + ' ' + ('COMMON.APPROVAL_FLOW.USERS' | translate)"
            [loadingText]="'COMMON.ACTIONS.LOADING' | translate"
            [notFoundText]="'COMMON.LABEL.NO_RESULTS' | translate"
            [attr.aria-label]="row.title | translateField: { obj: row, property: 'title' }"
            [ngModel]="userSelected[index].users" (ngModelChange)="onModelChange($event, index, row.users)"
            name="Visors_{{ index }}" labelForId="Visors_{{ index }}" [loading]="viewUsersLoading"
            [clearSearchOnAdd]="true" [class.error]="approvalFlow.submitted && (userSelected[index]?.users.length < row.approvers)">
            <ng-template ng-label-tmp let-item="item" let-clear="clear">
              <span class="ng-value-label">{{ item.fullname }}</span>
              <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
            </ng-template>
          </ng-select>
          <small *ngIf="approvalFlow.submitted && (userSelected[index]?.users.length < row.approvers)"
                 class="form-text text-danger">
            {{ 'COMMON.APPROVAL_FLOW.MESSAGE_REQUIRED' | translate }}
          </small>
        </div>
      </div>
    </div>

  </div>

  <div class="modal-footer approval-flow-footer">
    <button type="submit" class="btn btn-primary approval-flow-action" rippleEffect>
      <lucide-icon name="save" [size]="16"></lucide-icon>
      <span>{{ 'COMMON.BUTTONS.SAVE' | translate }}</span>
    </button>
    <button *ngIf="canClose" type="button" class="btn btn-outline-primary approval-flow-action" rippleEffect (click)="cancel()">
      <lucide-icon name="x" [size]="16"></lucide-icon>
      <span>{{ 'COMMON.BUTTONS.CLOSE' | translate }}</span>
    </button>
  </div>
</form>
